import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './estilos/global.css';
import { App } from './App';
import { ProvedorSessao } from './auth/SessaoContext';
import { ROTAS_GUIAS } from './conteudo/guias';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html.');

const arvore = (
  <StrictMode>
    <BrowserRouter>
      <ProvedorSessao>
        <App />
      </ProvedorSessao>
    </BrowserRouter>
  </StrictMode>
);

/**
 * As páginas públicas vêm pré-renderizadas do build (ver `prerenderizar.mjs`),
 * e só elas. Hidratar aproveita esse HTML; nas demais rotas o `#raiz` traz a
 * marcação da landing por causa do fallback do SPA, e tentar hidratar ali daria
 * erro de incompatibilidade — nesse caso o certo é desenhar do zero.
 *
 * A lista tem que espelhar a do `prerenderizar.mjs`.
 */
const PRE_RENDERIZADAS = [
  '/',
  '/privacidade',
  '/desenvolvedores',
  ...ROTAS_GUIAS,
];

if (
  PRE_RENDERIZADAS.includes(window.location.pathname) &&
  raiz.hasChildNodes()
) {
  hydrateRoot(raiz, arvore);
} else {
  createRoot(raiz).render(arvore);
}
